<template>
  <div style="display: inline" class="text-xs-left">
    <template
      v-if="
        ((loadingProduct || loadingCategory) &&
          $store.state.shoptheme.includes(selectedBot.theme)) ||
        loadingSetting
      "
    >
      <div class="text-xs-center">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </div>
    </template>
    <a
      v-else
      href="javascript:void(0);"
      style="padding: 15px 0; display: inline"
      @click="onEditGenericButton"
    >
      <slot name="body">Link</slot>
    </a>

    <div
      v-if="isEdit"
      style="position: absolute; top: 0px"
      :style="{ right: right ? right : '-45px' }"
    >
      <div style="display: flex">
        <v-menu offset-y open-on-hover>
          <template #activator="{ on }">
            <v-btn class="extra-small" color="primary" fab outline v-on="on">
              <v-icon small>build</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile @click="onEditGenericButton">
              <v-list-tile-title class="primary-color">{{ $t('edit') }}</v-list-tile-title>
            </v-list-tile>
            <slot name="append"> </slot>
          </v-list>
        </v-menu>
      </div>
    </div>

    <v-dialog v-model="showModal" persistent max-width="768px">
      <v-card>
        <div class="text-xs-right">
          <v-spacer></v-spacer>
          <v-btn flat icon small fab @click="onClose">
            <v-icon>close</v-icon>
          </v-btn>
        </div>
        <v-card-text>
          <div v-if="button && showModal">
            <label for="name" class="caption">{{ $t('If customer clicks') }}</label>
            <div class="form-control" :class="{ 'has-error': errors.has('buttonName') }">
              <input
                v-model="title"
                v-validate="'required'"
                type="text"
                class="form-control"
                maxlength="20"
                name="buttonName"
                :data-vv-as="$t('Button Name')"
                :placeholder="$t('Button Name')"
                @blur="onTypeTitle(title)"
              />
              <v-layout wrap>
                <v-flex xs11 class="error--text">
                  {{ errors.first('buttonName') }}
                </v-flex>
                <v-flex xs1 class="text-xs-right caption grey--text">
                  {{ title.length }}/20
                </v-flex>
              </v-layout>
            </div>

            <v-tabs
              v-model="state"
              color="white"
              :slider-color="$vuetify.theme.primary"
              @change="onChangeType"
            >
              <v-tab :key="'link'" :href="'#link'" ripple>
                <em class="fas fa-link" />
                <span style="margin-left: 5px">{{ $t('Link') }}</span>
              </v-tab>
              <v-tab :key="'text'" :href="'#text'" ripple>
                <em class="fas fa-align-left" />
                <span style="margin-left: 5px">{{ $t('Text') }}</span>
              </v-tab>
              <v-tab :key="'call'" :href="'#call'" ripple>
                <em class="fas fa-phone" />
                <span style="margin-left: 5px">{{ $t('Tel') }}</span>
              </v-tab>
              <template v-if="$store.state.shoptheme.includes(selectedBot.theme) && showShopLink">
                <v-tab
                  :key="'shop'"
                  :href="'#shop'"
                  ripple
                  :class="{ 'not-active': products.length == 0 }"
                >
                  <em class="fas fa-shopping-basket" />
                  <span style="margin-left: 5px">{{ $t('Shop Service') }}</span>
                </v-tab>
              </template>

              <template v-if="showBroadcast">
                <v-tab :key="'broadcast'" :href="'#broadcast'" ripple>
                  <v-icon>link</v-icon>
                  <span style="margin-left: 5px">{{ $t('Broadcast') }}</span>
                </v-tab>
              </template>

              <template v-if="selectedBot.unlock_survey">
                <v-tab :key="'survey'" :href="'#survey'" ripple>
                  <v-icon>checklist</v-icon>
                  <span style="margin-left: 5px">{{ $t('survey') }}</span>
                </v-tab>
              </template>

              <template v-if="isEventTrackingEnabled">
                <v-tab :key="'event_tracking'" :href="'#event_tracking'" ripple>
                  <v-icon>timeline</v-icon>
                  <span style="margin-left: 5px">Event tracking</span>
                </v-tab>
              </template>

              <v-tab :key="'url_tracking'" :href="'#url_tracking'" ripple>
                <v-icon>track_changes</v-icon>
                <span style="margin-left: 5px">{{ $t('url_tracking') }}</span>
              </v-tab>

              <template v-if="isZervaEnabled">
                <v-tab :key="'zerva'" :href="'#zerva'" ripple>
                  <ZervaIcon />
                  <span style="margin-left: 5px">Zerva</span>
                </v-tab>
              </template>

              <v-tabs-items touchless style="margin-top: 15px">
                <div v-if="state == 'link'" :key="'link'">
                  <div v-if="state == 'link'" class="row">
                    <div class="col s12">
                      <div style="margin-bottom: 15px">
                        {{
                          $t(
                            'When customer clicks this button, bot will automatically take customer to this link'
                          )
                        }}
                      </div>
                      <div style="margin-bottom: 15px">
                        {{ $t('* Only use https: // or http://') }}
                      </div>
                      <template v-if="isEventTrackingEnabled">
                        <v-radio-group v-model="linkType" row>
                          <v-radio :label="$t('Link')" value="link" color="primary" />
                          <v-radio :label="'Link tracking'" value="link-tracking" color="primary" />
                        </v-radio-group>
                      </template>
                      <template v-else>
                        <label for="link" class="caption">{{ $t('Link') }}</label>
                      </template>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('buttonLink') }"
                    >
                      <template v-if="isEventTrackingEnabled && linkType == 'link-tracking'">
                        <LinkTrackingSelect
                          v-model="url"
                          v-validate="state == 'link' ? 'required|isUrl' : ''"
                          name="buttonLink"
                          :data-vv-name="'buttonLink'"
                          :data-vv-as="$t('Link')"
                        />
                      </template>
                      <template v-else>
                        <textarea
                          key="button-link"
                          v-model="url"
                          v-validate="state == 'link' ? 'required|isUrl' : ''"
                          name="buttonLink"
                          :data-vv-name="'buttonLink'"
                          rows="10"
                          class="form-control"
                          style="width: 100%; resize: vertical"
                          :data-vv-as="$t('Link')"
                          placeholder="https://www.website.com"
                        ></textarea>
                      </template>
                      <span v-show="errors.has('buttonLink')" class="text-error">
                        {{ errors.first('buttonLink') }}
                      </span>
                    </div>
                  </div>
                </div>

                <div v-if="state == 'text'" :key="'text'">
                  <div style="margin-bottom: 20px">
                    {{
                      $t(
                        'If customer clicks this button, it will send this message to your customer (you can edit the answer in conversation page)'
                      )
                    }}
                  </div>
                  <div v-if="state == 'text'" class="text-xs-center">
                    <a
                      href="javascript:void(0);"
                      class="btn-advanced"
                      @click="showAdvanced = !showAdvanced"
                    >
                      {{ $t('Advanced') }}
                      <em
                        class="fa"
                        :class="{ 'fa-angle-down': showAdvanced, 'fa-angle-up': !showAdvanced }"
                      />
                    </a>
                  </div>
                  <div v-show="showAdvanced" class="row" style="margin-top: 15px">
                    <div class="col s12">
                      <label for="link" class="caption">Action</label>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('buttonPayload') }"
                    >
                      <input
                        key="button-payload"
                        v-model="payload"
                        v-validate="state == 'text' ? 'required' : ''"
                        type="text"
                        name="buttonPayload"
                        :data-vv-name="'buttonPayload'"
                        rows="5"
                        maxlength="1000"
                        class="form-control"
                        style="width: 100%; resize: none"
                        data-vv-as="Text"
                        placeholder="Type action"
                      />
                      <v-layout>
                        <v-flex class="error--text">
                          {{ errors.first('buttonPayload') }}
                        </v-flex>
                        <v-flex shrink class="text-xs-right caption grey--text">
                          {{ payload.length }}/1000
                        </v-flex>
                      </v-layout>
                    </div>
                  </div>
                </div>

                <div v-if="state == 'call'" :key="'call'">
                  <div v-if="state == 'call'" class="row">
                    <div class="col s12">
                      <div style="margin-bottom: 15px">
                        {{
                          $t(
                            'When customer clicks this button, Bot will automatically call to the given phone number.'
                          )
                        }}
                      </div>
                      <p>{{ $t('*This function will only work when user use mobile phone.') }}</p>
                      <label for="phone_number" class="caption">{{ $t('Tel') }}</label>
                    </div>
                    <div
                      class="col s12 form-control"
                      :class="{ 'has-error': errors.has('phone') || errorTel }"
                    >
                      <input
                        :key="'tel_' + editTimestamp"
                        v-model="call"
                        v-validate="{
                          required: true,
                          regex: /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{7,8}$|^[0-9]{3,4}$/
                        }"
                        name="phone"
                        type="text"
                      />
                      <div class="caption grey--text">Ex. +66812345678 or 123 or 1678</div>
                      <span v-if="errors.has('phone')" class="text-error">{{
                        errors.first('phone')
                      }}</span>
                    </div>
                  </div>
                </div>

                <template v-if="$store.state.shoptheme.includes(selectedBot.theme)">
                  <div v-if="state == 'shop'" :key="'shop'" :value="'shop'">
                    <p>
                      {{
                        $t(
                          'When customer clicks this button, Bot will take customer to Shop-Service.'
                        )
                      }}
                    </p>
                    <div
                      v-if="products.length == 0"
                      class="row warning-message text-xs-left"
                      style="margin: 0; margin-bottom: 15px"
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{
                            $t(
                              'please add product in Shop-Service, if you want to use this feature'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div :style="{ 'min-height': expandForSelect ? '300px' : '' }">
                      <multiselect
                        :key="'category_' + editTimestamp"
                        v-model="category"
                        class="mb-2"
                        :options="categoryOptions"
                        label="label"
                        :allow-empty="false"
                        select-label
                        selected-label
                        deselect-label
                        track-by="label"
                        :max-height="250"
                        :open-direction="'below'"
                        @select="onSelectCateogry"
                        @open="expandForSelect = true"
                        @close="expandForSelect = false"
                      ></multiselect>

                      <template v-if="['powerbuy'].includes(selectedBot.theme)">
                        <div v-if="loadingPowerbuyProduct" class="text-xs-center">
                          <v-progress-linear :indeterminate="true" :height="2"></v-progress-linear>
                        </div>
                        <template v-else>
                          <multiselect
                            :key="'product_' + editTimestamp"
                            v-model="product"
                            :options="powerbuyProducts"
                            label="label"
                            select-label
                            selected-label
                            :placeholder="$t('Products')"
                            track-by="label"
                            :max-height="250"
                            :open-direction="'below'"
                            :loading="loading"
                            @select="onSelectProduct"
                            @open="expandForSelect = true"
                            @close="expandForSelect = false"
                          />
                        </template>
                      </template>
                      <template v-else>
                        <multiselect
                          :key="'product_' + editTimestamp"
                          v-model="product"
                          :options="filterProducts"
                          label="label"
                          select-label
                          selected-label
                          :placeholder="$t('Products')"
                          track-by="label"
                          :max-height="250"
                          :open-direction="'below'"
                          :loading="loading"
                          @select="onSelectProduct"
                          @open="expandForSelect = true"
                          @close="expandForSelect = false"
                        ></multiselect>
                      </template>
                    </div>
                  </div>

                  <div v-if="state == 'transfer'" :key="'transfer'">
                    <p>{{ $t('Redirect customer to Cash Transfer page') }}</p>
                    <div
                      v-if="
                        setting &&
                        setting.allowtransfer &&
                        setting.allowtransfer.contentvalue == false
                      "
                      class="row warning-message text-xs-left"
                      style="margin: 0; margin-bottom: 15px"
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{ $t('you have not opened Bank Transfer in Shop-Service') }}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div v-if="state == 'credit_card'" :key="'credit_card'">
                    <p>{{ $t('Redirect customer to Credit Card payment page') }}</p>

                    <div
                      v-if="
                        setting && setting.allowcreditcard && selectedBot.paypal_merchantid == null
                      "
                      class="row warning-message text-xs-left"
                      style="margin: 0; margin-bottom: 15px"
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{
                            $t(
                              'You havent registered credit card payment. Go to Setting page to Link PayPal Account for chatbot.'
                            )
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      v-else-if="
                        setting &&
                        setting.allowcreditcard &&
                        setting.allowcreditcard.contentvalue == false
                      "
                      class="row warning-message text-xs-left"
                      style="margin: 0; margin-bottom: 15px"
                    >
                      <div style="display: flex">
                        <vue-simple-svg
                          :filepath="'/static/img/assets/_global/warning.svg'"
                          width="30px"
                          height="auto"
                          class="icon"
                        />
                        <div style="padding-left: 10px">
                          <div class="strong" style="margin-bottom: 10px">{{ $t('Warning!') }}</div>
                          {{ $t('you have not opened Credit card in Shop-Service') }}
                        </div>
                      </div>
                    </div>
                  </div>
                </template>
                <div v-if="state == 'broadcast'" :key="'broadcast'" class="text-xs-center">
                  <v-btn
                    :outline="payload != 'subscribeBroadcast'"
                    depressed
                    :color="payload == 'subscribeBroadcast' ? 'primary' : 'grey'"
                    :class="{ 'v-btn--active': payload == 'subscribeBroadcast' }"
                    @click="payload = 'subscribeBroadcast'"
                  >
                    <v-icon class="pr-2">link</v-icon>
                    <span>{{ $t('Subscribe') }}</span>
                  </v-btn>
                  <v-btn
                    :outline="payload != 'unsubscribeBroadcast'"
                    depressed
                    :color="payload == 'unsubscribeBroadcast' ? 'primary' : 'grey'"
                    :class="{ 'v-btn--active': payload == 'unsubscribeBroadcast' }"
                    @click="payload = 'unsubscribeBroadcast'"
                  >
                    <v-icon class="pr-2">link_off</v-icon>
                    <span>{{ $t('Unsubscribe') }}</span>
                  </v-btn>
                  <input
                    v-model="payload"
                    v-validate="'required'"
                    type="hidden"
                    name="broadcastPayload"
                    :data-vv-as="$t('Broadcast')"
                  />
                  <div v-if="errors.has('broadcastPayload')" class="text-xs-center error--text">
                    {{ errors.first('broadcastPayload') }}
                  </div>
                </div>

                <div v-if="state == 'survey'" :key="'survey'">
                  <v-autocomplete
                    v-model="survey"
                    v-validate="'required'"
                    :items="surveyOptions"
                    item-text="survey_name"
                    item-value="id"
                    return-object
                    :placeholder="$t('survey_select')"
                    outline
                    single-line
                    :data-vv-as="$t('survey')"
                    name="survey"
                    :error-messages="errors.collect('survey')"
                  >
                    <template #item="{ item }">
                      <v-list-tile-avatar
                        v-if="item.theme_config_json && item.theme_config_json.header"
                      >
                        <img
                          v-if="item.theme_config_json.header.image_url"
                          :src="item.theme_config_json.header.image_url"
                          alt="Avatar"
                          :style="{ objectFit: 'cover' }"
                        />
                        <v-icon v-else class="grey lighten-1 white--text">image</v-icon>
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.survey_name }}</v-list-tile-title>
                        <v-list-tile-sub-title>ID: {{ item.id }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </div>

                <div v-if="state == 'event_tracking'" :key="'event_tracking'">
                  <v-autocomplete
                    v-model="eventTracking"
                    v-validate="'required'"
                    :items="eventTrackingOptions"
                    item-text="label"
                    item-value="id"
                    return-object
                    :placeholder="$t('event_tracking_select')"
                    outline
                    single-line
                    data-vv-as="Event tracking"
                    name="eventTracking"
                    :error-messages="errors.collect('eventTracking')"
                  >
                    <template #item="{ item }">
                      <v-list-tile-content>
                        <v-list-tile-title>{{ item.label }}</v-list-tile-title>
                        <v-list-tile-sub-title>ID: {{ item.id }}</v-list-tile-sub-title>
                      </v-list-tile-content>
                    </template>
                  </v-autocomplete>
                </div>

                <template v-if="state === 'url_tracking'">
                  <div class="my-2">
                    {{
                      $t('If the customer presses this button, the bot will collect information')
                    }}
                  </div>
                  <div class="col s12 form-control" :class="{ 'has-error': errors.has('title') }">
                    <div class="caption">{{ $t('Title') }}</div>
                    <input
                      :key="'value_' + editTimestamp"
                      v-model="button.title"
                      v-validate="{
                        required: true
                      }"
                      name="title"
                      type="text"
                      :data-vv-as="$t('Title')"
                    />
                    <span v-if="errors.has('title')" class="text-error">
                      {{ errors.first('title') }}
                    </span>
                  </div>
                  <div class="col s12 form-control" :class="{ 'has-error': errors.has('value') }">
                    <div class="caption">{{ $t('Value') }}</div>
                    <input
                      :key="'value_' + editTimestamp"
                      v-model="button.payload"
                      v-validate="{
                        required: true
                      }"
                      name="value"
                      type="number"
                      :data-vv-as="$t('Value')"
                      @input="
                        (e) =>
                          e && e.target && e.target.value
                            ? (button.payload = Number(e.target.value))
                            : (button.payload = 0)
                      "
                    />
                    <span v-if="errors.has('value')" class="text-error">
                      {{ errors.first('value') }}
                    </span>
                  </div>
                  <div class="my-2">
                    {{ $t('and take the customer to this link') }}
                  </div>
                  <div class="col s12 form-control" :class="{ 'has-error': errors.has('link') }">
                    <div class="caption">
                      {{ $t('Link (must begin with https:// or http:// )') }}
                    </div>
                    <input
                      :key="'link_' + editTimestamp"
                      v-model="url"
                      v-validate="{
                        required: true,
                        regex: /^(https:\/\/|http:\/\/)/
                      }"
                      name="link"
                      type="text"
                      :data-vv-as="$t('Link')"
                      placeholder="https://www.website.com"
                    />
                    <span v-if="errors.has('link')" class="text-error">
                      {{ errors.first('link') }}
                    </span>
                  </div>
                </template>

                <template v-if="state == 'zerva'">
                  <ZervaServiceIdInput ref="zervaServiceIdInput" v-model="zervaServiceId" />
                </template>
              </v-tabs-items>
            </v-tabs>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" outline @click="onClose">{{ $t('cancel') }}</v-btn>
          <v-btn color="primary" depressed @click="onSave">{{ $t('Save') }}</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-tel-input/dist/vue-tel-input.css'
import { mapGetters } from 'vuex'

import powerbuyShopServicesApi from '@/api/powerbuy-shop-services'
import { handleApiError, handleResponse } from '@/api/util'
import surveyApi from '@/api/survey'
import LinkTrackingSelect from './LinkTrackingSelect'
import { FEATURE } from '@/constants/feature'
import eventTrackingApi from '@/api/event-tracking'
import dayjs from 'dayjs'
import ZervaIcon from '@/components/icons/Zerva.vue'
import ZervaServiceIdInput from './ZervaServiceIdInput.vue'

export default {
  components: {
    Multiselect,
    LinkTrackingSelect,
    ZervaIcon,
    ZervaServiceIdInput
  },
  props: {
    value: {
      default: undefined
    },
    isEdit: {
      default: false
    },
    right: {
      default: undefined
    },
    showShopLink: {
      default: true,
      type: Boolean
    },
    showBroadcast: {
      default: true,
      type: Boolean
    }
  },

  data: function () {
    return {
      showModal: false,
      button: {
        title: '',
        type: '',
        payload: '',
        url: ''
      },
      title: '',
      call: '',
      url: '',
      payload: '',
      survey: null,
      showAdvanced: false,
      state: 'link',
      type: 'link',
      product: null,
      errorTel: false,
      category: {
        label: 'All',
        value: 'all'
      },
      expandForSelect: false,
      editTimestamp: moment().format('x'),
      productListBySlug: [],
      loading: false,
      powerbuyProducts: [],
      loadingPowerbuyProduct: true,
      surveyOptions: [],
      linkType: 'link',
      eventTracking: null,
      eventTrackingOptions: [],
      zervaServiceId: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      currentLang: 'currentLang',
      products: 'getProducts',
      loadingProduct: 'getLoadingProduct',
      loadingSetting: 'getLoadingSetting',
      setting: 'getSetting',
      categories: 'getCategories',
      loadingCategory: 'getLoadingCategory'
    }),
    categoryOptions: function () {
      let categories = [
        {
          label: 'All',
          value: 'all'
        }
      ]
      if (!this.loadingCategory) {
        if (this.categories) {
          if (this.$store.state.thailandPostmartPage.includes(this.selectedBot.pageid)) {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.category = {
              label: 'สินค้าทั้งหมด',
              value: 'all'
            }
            categories = [
              ...categories,
              {
                label: 'Sales',
                value: 'sales'
              },
              ...this.categories.map(function (category) {
                return { label: category.title, value: category.slug }
              })
            ]
          } else if (['powerbuy'].includes(this.$store.state.selectedBot.theme)) {
            categories = [
              ...categories,
              ...this.categories.map(function (category) {
                return { label: category.category_name, value: category.category_name }
              })
            ]
          } else {
            categories = [
              ...categories,
              {
                label: 'Sales',
                value: 'sales'
              },
              ...this.categories.map(function (category) {
                return { label: category.name, value: category.id }
              })
            ]
          }
        }
      }
      return categories
    },
    currentType: function () {
      var vm = this
      if (this.button.type === 'web_url') {
        if (this.button.url.includes('{shopurl}')) {
          const category = ['powerbuy'].includes(vm.selectedBot.theme)
            ? vm.button.url.split('&category_name=')
            : vm.button.url.split('&category=')
          const result =
            category && category.length > 1
              ? vm.categoryOptions.find(function (value) {
                  return value.id === decodeURIComponent(category[1])
                })
              : null
          if (result) {
            vm.category = result
          } else {
            vm.category = vm.categoryOptions[0]
          }
          return 'shopurl'
        } else if (this.button.url === '{transferurl}') {
          return 'transferurl'
        } else if (this.button.url === '{creditcardurl}') {
          return 'creditcardurl'
        } else if (this.button.url === '{viewsummary}') {
          return 'viewsummary'
        } else if (this.button.url.includes('{redirect_url_tracking}')) {
          return 'url_tracking'
        } else {
          return 'web_url'
        }
      } else if (this.button.type === 'postback') {
        return 'postback'
      } else if (this.button.type === 'phone_number') {
        return 'phone_number'
      } else {
        return ''
      }
    },
    filterProducts: function () {
      let products = []
      const vm = this

      if (this.$store.state.thailandPostmartPage.includes(this.selectedBot.pageid)) {
        if (vm.category && vm.category.value === 'all') {
          products = vm.products
        } else {
          products = vm.productListBySlug
        }
        if (products) {
          return products.map((product) => {
            return { label: product.product_title, value: product.sku }
          })
        } else {
          return []
        }
      } else if (['powerbuy'].includes(vm.$store.state.selectedBot.theme)) {
        if (vm.category && vm.category.value === 'all') {
          products = vm.products
        }
        if (products) {
          return products.map((product) => {
            return { label: product.product_name, value: product.product_name }
          })
        } else {
          return []
        }
      } else {
        if (vm.category && vm.category.value === 'all') {
          products = vm.products
          return products.map((product) => {
            return { label: product.name, value: product.id }
          })
        } else if (vm.category && vm.category.value === 'sales') {
          products = vm.products.filter((product) => {
            if (parseFloat(product.price) !== parseFloat(product.discountprice)) {
              return true
            } else {
              if (product.productstock) {
                product.productstock.map(function (stock) {
                  if (parseFloat(stock[3]) > parseFloat(stock[4])) {
                    return true
                  }
                })
              }
            }
            return false
          })
          return products.map((product) => {
            return { label: product.name, value: product.id }
          })
        } else {
          products = vm.products.filter((product) => {
            return product.categoryid == vm.category.value
          })

          if (products) {
            return products.map((product) => {
              return { label: product.name, value: product.id }
            })
          }
        }
      }
      return []
    },
    isEventTrackingEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.EVENT_TRACKING)
    },
    isZervaEnabled() {
      return (this.selectedBot.features || '').split(',').includes(FEATURE.ZERVA_BOOKING)
    }
  },

  watch: {
    value: function () {
      var vm = this
      vm.reset()
    }
  },
  created: function () {
    this.reset()
    if (['powerbuy'].includes(this.selectedBot.theme)) {
      this.powerbuyProducts = this.filterProducts
      this.loadingPowerbuyProduct = false
    }

    if (this.selectedBot.unlock_survey) {
      this.fetchSurveyOptions()
    }

    if (this.isEventTrackingEnabled) {
      this.fetchEventTrackingOptions()
    }
  },
  methods: {
    async handleFilterProducts(category_name = undefined) {
      const data = await this.getProductByCategoryName(category_name)
      const filterProducts = data.map((product) => {
        return { label: product.product_name, value: product.product_name }
      })
      this.powerbuyProducts = filterProducts
      return filterProducts
    },
    async getProductByCategoryName(category_name = undefined) {
      const data = {
        config: {
          params: {
            pageId: this.selectedBot.pageid,
            category_name: category_name
          }
        }
      }
      try {
        const response = await powerbuyShopServicesApi.getProducts(data)
        await handleResponse()
        if (response.data && response.data.data) {
          return response.data.data
        } else {
          return []
        }
      } catch (error) {
        handleApiError(error)
        return false
      }
    },
    getParameterByName(name, url) {
      if (!url) url = window.location.href
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    },
    async onEditGenericButton() {
      var vm = this
      if (this.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
        if (vm.button.type === 'web_url' && vm.button.url.includes('{shopurl}')) {
          var category = vm.getParameterByName('category', vm.button.url)
          if (category != null) {
            if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
              await vm.getProductBySlugThailandPostmart(category)
            }
            vm.category = vm.categoryOptions.find(function (value) {
              return value.value == category
            })
            if (!vm.category) {
              vm.category = vm.categoryOptions[0]
            }
          } else {
            vm.category = vm.categoryOptions[0]
          }

          var product = ['powerbuy'].includes(vm.selectedBot.theme)
            ? vm.getParameterByName('product_name', vm.button.url)
            : vm.getParameterByName('pid', vm.button.url)
          if (product != null) {
            let filterProducts = []
            if (['powerbuy'].includes(vm.selectedBot.theme)) {
              vm.loadingPowerbuyProduct = true
              filterProducts = await vm.handleFilterProducts(
                vm.category && vm.category.value ? vm.category.value : undefined
              )
              vm.loadingPowerbuyProduct = false
            } else {
              filterProducts = vm.filterProducts
            }
            const hasFoundProduct = filterProducts.find(function (value) {
              return value.value == decodeURIComponent(product)
            })

            vm.product = hasFoundProduct

            if (!vm.product) {
              vm.product = filterProducts[0]
            }
          } else {
            vm.product = null
          }
        }
      }
      vm.reset()
      vm.showModal = true
    },
    onSelectCateogry: async function (category) {
      var vm = this
      if (vm.$store.state.shoptheme.includes(vm.selectedBot.theme)) {
        vm.product = null
      }
      if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
        vm.getProductBySlugThailandPostmart(category.value)
      }

      vm.loadingPowerbuyProduct = true
      await vm.handleFilterProducts(category.value)
      vm.loadingPowerbuyProduct = false
    },
    onSelectProduct: function () {},
    onInput({ isValid }) {
      if (this.state === 'call') {
        this.errorTel = !isValid
      } else {
        this.errorTel = false
      }
    },
    onSave: async function () {
      var vm = this
      var data = {
        title: vm.title
      }
      if (vm.state === 'call') {
        data.type = 'phone_number'
        data.payload = vm.call
      } else if (vm.state === 'text') {
        data.type = 'postback'
        data.payload = vm.payload
      } else if (vm.state === 'link') {
        data.type = 'web_url'
        data.url = vm.url
      } else if (vm.state === 'shop') {
        data.type = 'web_url'
        if (['powerbuy'].includes(vm.selectedBot.theme)) {
          data.url = `{shopurl}&category_name=${encodeURIComponent(vm.category.value)}`

          if (vm.product) {
            data.url += `&product_name=${encodeURIComponent(vm.product.value)}`
          }
        } else {
          data.url = `{shopurl}&category=${encodeURIComponent(vm.category.value)}`

          if (vm.product) {
            data.url += `&pid=${encodeURIComponent(vm.product.value)}`
          }
        }
      } else if (vm.state === 'transfer') {
        data.type = 'web_url'
        data.url = '{transferurl}'
      } else if (vm.state === 'credit_card') {
        data.type = 'web_url'
        data.url = '{creditcardurl}'
      } else if (vm.state === 'broadcast') {
        data.type = 'postback'
        data.payload = vm.payload
      } else if (vm.state === 'survey') {
        if (this.survey) {
          data.type = 'web_url'
          data.url = `{survey_url_${this.survey.id}}`
        }
      } else if (vm.state === 'event_tracking') {
        if (this.eventTracking) {
          data.type = 'web_url'
          data.url = `{event_tracking_${this.eventTracking.id}}`
        }
      } else if (vm.state === 'url_tracking') {
        data.type = 'web_url'
        data.payload = vm.button.payload
        const url = decodeURIComponent(vm.url)
        data.url = `{redirect_url_tracking}&action=${vm.button.title}&value=${vm.button.payload}&redirect_url=${url}`
      } else if (vm.state === 'zerva') {
        const valid = await this.$refs.zervaServiceIdInput.$validator.validate()
        if (!valid) return
        data.type = 'web_url'
        data.url = `{zerva_service_url_${this.zervaServiceId}}`
      }
      if (this.errorTel) {
        return false
      }

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }

        vm.cache_button = JSON.stringify(data)
        vm.showModal = false
        vm.$emit('onSave', data)
        vm.reset()
      })
    },
    onClose: function () {
      this.button = JSON.parse(this.cache_button)
      this.showModal = false
      // this.clearField()
    },
    onChangeType: function () {
      if (this.state === 'text') {
        if (this.payload === '') {
          this.payload = this.title
        }
      }
      if (this.state !== 'call') {
        this.errorTel = false
      }
      if (this.state === 'url_tracking') {
        this.button.title = ''
        this.button.payload = 0
        this.button.url = ''
      }
      this.errors.clear()
    },
    onTypeTitle: function (text) {
      var vm = this
      if (vm.state === 'text') {
        vm.$nextTick(function () {
          vm.payload = text
        })
      }
    },
    getCategories: async function () {
      let vm = this
      if (vm.$store.state.thailandPostmartPage.includes(vm.selectedBot.pageid)) {
        api.getCategoriesThailandPostmart(
          { pageid: vm.selectedBot.pageid },
          function (error, response) {
            if (error) {
              throw error
            }
            var categorylist = response.data
            if (categorylist) {
              categorylist.map(function (category) {
                vm.categoryOptions.push({
                  label: category.title,
                  value: category.slug
                })
              })
            }
            return
          }
        )
      } else {
        var data = {
          pageid: vm.selectedBot.pageid
        }
        if (
          vm.selectedBot.useketshop == true &&
          vm.selectedBot.ketshop_api_key &&
          vm.selectedBot.ketshop_api_secret
        ) {
          data['ketshop_api_key'] = vm.selectedBot.ketshop_api_key
          data['ketshop_api_secret'] = vm.selectedBot.ketshop_api_secret
        }
        api.getCategories(data, function (error, response) {
          if (error) {
            console.error(error)
            throw error
          }
          var categorylist = response.categorylist
          if (categorylist) {
            categorylist.map(function (category) {
              vm.categoryOptions.push({
                label: category.name,
                value: category.id
              })
            })
          }
          return
        })
      }
    },
    async getProductBySlugThailandPostmart(slug) {
      var vm = this
      let data = {
        slug: slug,
        pageid: vm.selectedBot.pageid
      }
      vm.loading = true
      await api.getProductBySlugThailandPostmart(data, function (error, response) {
        if (error) {
          throw error
        }
        var productlist = response.data
        if (productlist) {
          vm.productListBySlug = productlist
          vm.loading = false
        }
        return
      })
    },
    async fetchSurveyOptions() {
      try {
        const response = await surveyApi.getAll({
          params: {
            page_id: this.selectedBot.pageid,
            is_used: true
          }
        })

        if (response.status === 200) {
          this.surveyOptions = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async fetchEventTrackingOptions() {
      try {
        const response = await eventTrackingApi.getTrackingUrls(this.selectedBot.pageid, {
          offset: 0,
          limit: 1000,
          date_from: dayjs(0).format(),
          date_to: dayjs().format()
        })
        if (response.status === 200) {
          this.eventTrackingOptions = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    clearField: function () {
      var vm = this
      vm.state = 'link'
      vm.button = {
        title: '',
        type: '',
        payload: '',
        url: ''
      }
      vm.title = ''
      vm.call = ''
      vm.url = ''
      vm.payload = ''
      vm.errorTel = false
    },
    reset: function () {
      const vm = this
      vm.clearField()
      vm.errors.clear()
      vm.$forceUpdate()
      vm.editTimestamp = moment().format('x')

      vm.button = Object.assign({}, vm.value)
      vm.cache_button = JSON.stringify(vm.value)

      vm.title = vm.button.title

      if (vm.button.type === 'phone_number') {
        vm.call = vm.button.payload
        vm.state = 'call'
      } else if (vm.button.type === 'postback') {
        vm.payload = vm.button.payload
        if (['unsubscribeBroadcast', 'subscribeBroadcast'].includes(vm.button.payload)) {
          vm.state = 'broadcast'
        } else {
          vm.state = 'text'
        }
        if (vm.button.title !== vm.button.payload) {
          vm.showAdvanced = true
        }
      } else if (vm.button.type === 'web_url' && vm.button.url.includes('{shopurl}')) {
        const url = ['powerbuy'].includes(vm.selectedBot.theme)
          ? vm.button.url.split('&category_name=')[1]
          : vm.button.url.split('&category=')[1]
        let category = url && url.split('&')[0]
        if (category && category.length > 1) {
          category = decodeURIComponent(category)
          const result = vm.categoryOptions.find(function (value) {
            return value.value == category
          })
          if (!result) {
            vm.category = vm.categoryOptions[0]
          } else {
            vm.category = result
          }
        } else {
          vm.category = vm.categoryOptions[0]
        }
        vm.state = 'shop'
      } else if (vm.button.type === 'web_url' && vm.button.url === '{transferurl}') {
        vm.state = 'transfer'
      } else if (vm.button.type === 'web_url' && vm.button.url === '{creditcardurl}') {
        vm.state = 'credit_card'
      } else if (vm.button.type === 'web_url' && vm.button.url.startsWith('{survey_url_')) {
        vm.state = 'survey'
        const id = vm.button.url.replace(/{survey_url_(\d+)}/, '$1')
        vm.survey = vm.surveyOptions.find((option) => option.id === id) || null
      } else if (vm.button.type === 'web_url' && vm.button.url.startsWith('{event_tracking_')) {
        vm.state = 'event_tracking'
        const id = vm.button.url.replace(/{event_tracking_(.+)}/, '$1')
        vm.eventTracking = vm.eventTrackingOptions.find((option) => option.id === id) || null
      } else if (
        vm.button.type === 'web_url' &&
        vm.button.url.includes('{redirect_url_tracking}')
      ) {
        if (vm.button.url) {
          const url = new URL(
            vm.button.url.replace('{redirect_url_tracking}&', window.location.origin + '?')
          )
          const queryParams = url.searchParams
          vm.url = queryParams.get('redirect_url')
          vm.button.payload = queryParams.get('value') ? Number(queryParams.get('value')) || 0 : 0
          vm.button.title = queryParams.get('action')
        }
        vm.state = 'url_tracking'
      } else if (vm.button.type === 'web_url' && vm.button.url.startsWith('{zerva_service_url_')) {
        vm.state = 'zerva'
        const id = vm.button.url.replace(/{zerva_service_url_(.+)}/, '$1')
        vm.zervaServiceId = id
      } else if (vm.button.type === 'web_url') {
        vm.url = vm.button.url
        vm.state = 'link'
      }

      vm.linkType = 'link'
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/chatbot/AddGenericButton.vue